/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const BusinessCreditRiskTestimonial = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="Allianz"
      title={t('The Allianz Italy Case Study: Growth and Compliance From a Single Data Source')}
      summary={t(
        'Allianz Italy runs KYB, AML and credit-risk checks on every client from one data source — ownership structures, financials and credit scores in a single unified feed, replacing what used to require multiple providers.',
      )}
      href="/the-allianz-italy-case-study-driving-growth-and-ensuring-compliance-with-a-single-data-source"
    />
  );
};
